import { render } from "./productList.vue?vue&type=template&id=4805a2b7&scoped=true"
import script from "./productList.vue?vue&type=script&lang=js"
export * from "./productList.vue?vue&type=script&lang=js"

import "./productList.vue?vue&type=style&index=0&id=4805a2b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4805a2b7"]])

export default __exports__